import { useTheme } from './useTheme';

/** Lucide `lamp-desk`, from the vendored font the sidebar icons use. */
const LAMP = String.fromCodePoint(0xe2da);

/**
 * The header's one-click theme switch: a desk lamp, lit in the light theme and
 * dimmed in the dark one. A click pins the opposite of what is on screen, so it
 * leaves `system`; Settings → Appearance is where `system` is picked again.
 */
export function ThemeToggle() {
  const { theme, setPreference } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} theme`;

  return (
    <button
      className={theme === 'light' ? 'theme-toggle theme-toggle--lit' : 'theme-toggle'}
      type="button"
      title={label}
      aria-label={label}
      onClick={() => setPreference(next)}
    >
      <span className="theme-toggle__icon" aria-hidden="true">
        {LAMP}
      </span>
    </button>
  );
}
